import PropTypes from 'prop-types';
import Footer from '@components/common/Footer';

const footerLinks = [
  {
    label: 'Privacy Policy',
    href: 'https://micruity.com/privacy',
  },
  {
    label: 'Terms of Use',
    href: 'https://micruity.com/terms-of-use',
  },
];

const propTypes = {
  children   : PropTypes.node.isRequired,
  pageTitle  : PropTypes.node.isRequired,
  pageName   : PropTypes.string,
  style      : PropTypes.shape({}),
  disclosure : PropTypes.arrayOf(PropTypes.string),
  /**
   * Optional custom header component. When provided, replaces the default header.
   * The component receives no props and should render a complete header including skip navigation.
   */
  headerComponent: PropTypes.node,
};

function PageLayout({ children, pageTitle, pageName, style, disclosure, headerComponent }) {
  // If custom header is provided, use it instead of the default
  if (headerComponent) {
    return (
      <>
        {headerComponent}
        <main
          className="global__main"
          id="main"
        >
          <div className="global__inner">
            <div className={'page' + (pageName ? ` page--${pageName}` : '')}>
              {children}
            </div>
          </div>
        </main>
        <Footer variant="election">
          <div className="global__inner">
            <Footer.Disclosure text={disclosure} />
            <hr aria-hidden="true" />
            <div className="footer__logo">
              <span
                role="img"
                aria-label="Powered by Micruity"
              >
              </span>
            </div>
            <Footer.LegalLinks
              links={footerLinks}
              asNav
            />
            <Footer.Copyright />
          </div>
        </Footer>
      </>
    );
  }

  return (
    <>
      <nav className="a11y-nav">
        <a
          href="#main"
          className="skip-to-main-content"
        >Skip to main content
        </a>
      </nav>
      <header
        className="global__header"
        style={style}
        aria-label="Site header"
      >
        <div className="global__inner">
          <div className="header__title">{pageTitle}</div>
        </div>
      </header>
      <main
        className="global__main"
        id="main"
      >
        <div className="global__inner">
          <div className={'page' + (pageName ? ` page--${pageName}` : '')}>
            {children}
          </div>
        </div>
      </main>
      <Footer variant="election">
        <div className="global__inner">
          <Footer.Disclosure text={disclosure} />
          <hr aria-hidden="true" />
          <div className="footer__logo">
            <span
              role="img"
              aria-label="Powered by Micruity"
            >
            </span>
          </div>
          <Footer.LegalLinks
            links={footerLinks}
            asNav
          />
          <Footer.Copyright />
        </div>
      </Footer>
    </>
  );
}

PageLayout.propTypes = propTypes;

export default PageLayout;
